export default __webpack_public_path__ + "static/media/banner1.d9c486a4.jpg";